import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Upper Body / Core' second='Workout 05' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: 'Shoulders / Biceps',
							value: 'Front Raises w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10 - 12',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
					[
						{
							header: 'Shoulders / Biceps',
							value: 'Lateral Raises w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 8 - 10',
						},
						{
							header: 'ABS / Core',
							value: 'Plank Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 secs',
						},
					],
					[
						{
							header: 'Shoulders / Biceps',
							value: 'Curls w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Rest',
						},
						{
							header: 'Sec / Minutes',
							value: '...',
						},
					],
					[
						{
							header: 'Shoulders / Biceps',
							value: '(Biceps) Static Holds w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x (1min)',
						},
						{
							header: 'ABS / Core',
							value: 'Toe Touches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 secs',
						},
					],
					[
						{
							header: 'Shoulders / Biceps',
							value: 'Jog in Place',
						},
						{
							header: 'Sets / Reps',
							value: '45 sec',
						},
						{
							header: 'ABS / Core',
							value: 'Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '25 secs',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
